import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth-guard';
import { changePasswordGuard } from './core/guards/change-password-guard';
import { guestGuard } from './core/guards/guest-guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    title: 'Iniciar sesión',
    data: { title: 'Iniciar sesión' },
    loadComponent: () =>
      import('./features/auth/pages/login-page/login-page').then((component) => component.LoginPage),
  },
  {
    path: 'change-password',
    canActivate: [changePasswordGuard],
    title: 'Cambiar contraseña',
    data: { title: 'Cambiar contraseña' },
    loadComponent: () =>
      import('./features/auth/pages/change-password-page/change-password-page').then(
        (component) => component.ChangePasswordPage,
      ),
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./core/layout/private-layout/private-layout').then(
        (component) => component.PrivateLayout,
      ),
    children: [
      {
        path: 'home',
        title: 'Inicio',
        data: { title: 'Inicio' },
        loadComponent: () =>
          import('./features/home/pages/home-page/home-page').then(
            (component) => component.HomePage,
          ),
      },
      {
        path: 'companies',
        title: 'Empresas',
        data: { title: 'Empresas' },
        loadComponent: () =>
          import('./features/companies/pages/companies-page/companies-page').then(
            (component) => component.CompaniesPage,
          ),
      },
      {
        path: 'menu',
        title: 'Menú',
        data: { title: 'Menú' },
        loadComponent: () =>
          import('./features/menu/pages/menu-page/menu-page').then((component) => component.MenuPage),
      },
      {
        path: 'devices',
        title: 'Dispositivos',
        data: { title: 'Dispositivos' },
        loadComponent: () =>
          import('./features/devices/pages/devices-page/devices-page').then(
            (component) => component.DevicesPage,
          ),
      },
      {
        path: 'company-devices',
        title: 'Mis Dispositivos',
        data: { title: 'Mis Dispositivos' },
        loadComponent: () =>
          import('./features/company-devices/pages/company-devices-page/company-devices-page').then(
            (component) => component.CompanyDevicesPage,
          ),
      },
      {
        path: 'licenses',
        title: 'Licencias',
        data: { title: 'Licencias' },
        loadComponent: () =>
          import('./features/licenses/pages/licenses-page/licenses-page').then(
            (component) => component.LicensesPage,
          ),
      },
      {
        path: 'multimedia',
        title: 'Multimedia',
        data: { title: 'Multimedia' },
        loadComponent: () =>
          import('./features/multimedia/pages/multimedia-page/multimedia-page').then(
            (component) => component.MultimediaPage,
          ),
      },
      {
        path: 'playlists',
        title: 'Playlists',
        data: { title: 'Playlists' },
        loadComponent: () =>
          import('./features/playlists/pages/playlists-page/playlists-page').then(
            (component) => component.PlaylistsPage,
          ),
      },
      {
        path: 'users',
        title: 'Usuarios',
        data: { title: 'Usuarios' },
        loadComponent: () =>
          import('./features/users/pages/users-page/users-page').then(
            (component) => component.UsersPage,
          ),
      },
      {
        path: 'roles',
        title: 'Roles',
        data: { title: 'Roles' },
        loadComponent: () =>
          import('./features/roles/pages/roles-page/roles-page').then(
            (component) => component.RolesPage,
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app/home',
  },
  {
    path: '**',
    redirectTo: 'app/home',
  },
];
